import moment from 'moment';

export function formatTimePassed(date: string) {
  if (!date) {
    return '';
  }
  const m = moment(date);
  return m.isValid() ? m.fromNow(true) : '';
}
